import styled from 'styled-components';

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    padding: 8px 15px;  
    cursor: pointer;
    :active {
        color: #fff;
        background-color: var(--morienGreen);
    }
`;


export const DivNum = styled.div`
   position: absolute;
    top: 4px;
    right: 6px; 
    background-color: #ff3b30;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid white;
    box-shadow: 0 0 4px rgba(0,0,0,0.1);
    animation: pulse-animation 2s infinite;

    @keyframes pulse-animation {
      0% { box-shadow: 0 0 0 0px rgba(255, 59, 48, 0.5); }
      70% { box-shadow: 0 0 0 6px rgba(255, 59, 48, 0); }
      100% { box-shadow: 0 0 0 0px rgba(255, 59, 48, 0); }
    }
`;

export const Line = styled.div`
`

export const MLabel = styled.small`
    color: #6c757d;
`

export const Dialog = styled.div`
  position: fixed;
  top: 30%;
  left: 50%;    
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  border: 1px solid rgba(112, 76, 182, 0.1);
  border-radius: 10px;
  width: 85vw;    
  max-width: 500px;
  z-index: 100;
`;

export const DialogTitle = styled.div`    
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid rgba(112, 76, 182, 0.3);
`;

export const TextTile = styled.div`
  margin: 6px 10px;
`;

export const BtnClose = styled.button`
padding: 6px 15px;
cursor: pointer;
border: none;
outline: none;
background: none;
font-size: 1.25rem;
font-weight: bold;
border-radius: 10px;
:active {
    background-color: green;
    color: red;
}
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

export const Overlay = styled.div`
  position: fixed;
  opacity: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: all;
  z-index: 99;
`;



export const NoticeItem = styled.div`
  display: flex;
  padding:8px;
  border-bottom: 1px solid #e5e7eb;
  gap: 16px;
  width: 100%;
  cursor: pointer;
  transition: background 0.2s;
  :hover {
    background-color: #f9fafb;
  }

  .icon-box {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      color: white;
  }

  .icon-success { background-color: #059669; }
  .icon-info { background-color: #3b82f6;}
  .icon-primary { background-color: #2563eb; }
  .icon-error { background-color: #ef4444; }
  .is-seen { background-color: #b1b7b6; }
  .notice-content {
      flex: 1;
  }

  .notice-time {
    font-size: 11px;
    color: #9ca3af;
    margin-bottom: 4px;
  }
  .notice-title {
    font-size: 14px;
    font-weight: 700;
    color: #1f2937;
    line-height: 1.4;
  }

  .notice-desc {
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .chevron {
    align-self: center;
    color: #d1d5db;
  }
`;


export const NoticeDetail = styled.div`
  overflow-y: auto;
  padding: 0 12px;
  width: 100%;

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  background-color: var(--emerald-700);
  color: white;
  font-size: 11px;
  font-weight: 700;
  border-radius: 4px;
  margin-bottom: 12px;
}

.detail-box {
  background-color: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
  font-size: 14px;
}


.modal-footer {
  padding-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
}

.btn-primary {
  width: 100%;
  padding: 12px;
  background-color:  #059669;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
  font-size: 15px;
}

.btn-primary:hover {
  background-color: #059669;
}

`;

